import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Sections from '../components/dashboard/sections/Sections';
import Students from '../components/dashboard/students/Students';
import Attendance from '../components/dashboard/attendance/Attendance';
import Sidebar from '../components/dashboard/Sidebar';
import Fees from '../components/dashboard/fees/Fees';
import History from '../components/dashboard/history/History';

const Dashboard = () => {
  

  return (
    <section>
      <div className="relative flex lg:flex-row h-screen">
        {/* Sidebar */}
        <div className={`top-0 bottom-0 left-0 fixed z-60 md:h-full bg-gray-800 text-white sm:block`} style={{ zIndex: "50" }}>
          <Sidebar />
        </div>

        {/* Content */}
        <div className="flex flex-grow justify-end">
          {/* Dummy div to take the same sidebar width */}
          <div className='w-6 lg:w-10'></div>

          {/* Sections */}
          <div className="ml-3 w-full" style={{ height: '100vh', overflowY: 'scroll' }}>
            <Routes>
              <Route path="/sections" element={<Sections />} />
              <Route path="/students" element={<Students />} />
              <Route path="/attendance" element={<Attendance />} />
              <Route path="/fees" element={<Fees />} />
              <Route path="/history" element={<History />} />
            </Routes>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Dashboard;
